import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 14l4 -4l-4 -4","key":"svg-0"}],["path",{"d":"M19 10h-11a4 4 0 1 0 0 8h1","key":"svg-1"}]]

const IconArrowForwardUp = createReactComponent('outline', 'arrow-forward-up', 'ArrowForwardUp', __iconNode);

export default IconArrowForwardUp;